import { Navigate } from 'react-router-dom'
import { isTokenValid } from './TokenHandler'

const RedirectLoggedIn = ({ element }) => {
  return isTokenValid() ? <Navigate to='/dashboard' /> : element
}

export default RedirectLoggedIn
